var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gs-data-full"},[_c('div',{staticClass:"gs-data-full__container"},_vm._l((_vm.newsPrint),function(newItem,index){return _c('GSDataNewsItem',{key:index,attrs:{"new-item":newItem},on:{"open-media":_vm.onOpenMedia}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }